import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { SimulatedFlightFacade } from '../+state/simulated-flight/simulated-flight.facade';
import { PostedFlightFacade } from '../+state/posted-flight/posted-flight.facade';

@Component({
  selector: 'sd-portal-simulated-flight-audit',
  templateUrl: './simulated-flight.component.html',
  styleUrls: ['./simulated-flight.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SimulatedFlightComponent implements OnInit {
  constructor(
    readonly simulatedFlightFacade: SimulatedFlightFacade,
    readonly postedFlightFacade: PostedFlightFacade
  ) {}

  ngOnInit() {
    this.simulatedFlightFacade.loadSimulatedFlight();
  }
}
